import { ReadReportInstancesCriteria } from 'adapter/out/client/reportInstances/readReportInstancesApiClient';
import { ReportInstance } from 'domain/entity/reportInstance';
import getGenericUseCase from 'use-case/genericUseCase';

const readReportInstancesUseCase = getGenericUseCase<ReportInstance[], ReadReportInstancesCriteria>((client, criteria) => client(criteria));

export default readReportInstancesUseCase;
